import { createSelector } from '@reduxjs/toolkit'
import get from 'lodash/get'

import { Billing, BillingState } from 'common/billing/interfaces/billing'
import { ISidebarAccount } from 'common/core/interfaces/sideBarAccount'
import {
  getCurrentAccount,
  getCurrentAccountUser,
  IExtendedCurrentAccount,
} from 'common/core/selectors/appSelectors'
import { EmailBillingStats, SmsBillingStats } from 'shared/api/requests/settings/stats/schemas'

export const getRootBillingState = (state: RootState) => state.billing

export const getBillingState = (state: RootState): BillingState => state.billing.state

export const getSmsStats = createSelector(
  [getRootBillingState],
  (billing): SmsBillingStats => billing.smsStats,
)

export const getEmailStats = createSelector(
  [getRootBillingState],
  (billing): EmailBillingStats => billing.emailStats,
)

export const getHasBillingAccess = createSelector(
  [getCurrentAccountUser],
  (user) => user?.has_billing_access || false,
)

export const getPageAndHasBillingAccess = (state: RootState) => {
  const page: IExtendedCurrentAccount | ISidebarAccount | null = getCurrentAccount(state)
  const hasBillingAccess = get(state, 'app.currentAccountUser.has_billing_access', false)

  return { page, hasBillingAccess }
}

export const getArePaymentsEnabled = createSelector([getCurrentAccount], (account) =>
  Boolean(account.payments_enabled),
)

export const getDisableProductModal = (state: RootState): Billing['disableProductModal'] =>
  state.billing.disableProductModal

export const getPaymentCardRenewalModalState = (state: RootState) =>
  state.billing.paymentCardRenewalModal

export const getIsBillingNextActionModalOpen = createSelector(
  [getRootBillingState],
  (billing): boolean => billing.nextActionModal.isOpen,
)
